import React from "react";
import cookie from "js-cookie";
import axios from "axios";
import windowSize from "react-window-size";
import {
  InfoBox,
  Input,
  Image,
  Row,
  Column,
  Button,
  Text,
} from "../../globalComponents";
import Logo from "../../assets/logos/Main_Logo.png";
import Page_Background from "../../assets/Page_Background.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

class Login extends React.Component {
  state = {
    email: "",
    password: "",
    name: "",
    passwordConfirm: "",
    error: { name: "", text: "" },
  };
  signup = () => {
    this.setState({ loading: false });
    if (this.state.password !== this.state.passwordConfirm)
      this.setState({
        error: { name: "general", text: "Passwords Must Match" },
        loading: false,
      });
    else
      axios
        .post("/user/signup", {
          email: this.state.email,
          name: this.state.name,
          password: this.state.password,
        })
        .then((res) => {
          if (res.data.success) {
            this.setState({ error: { name: "", text: "", loading: false } });
          } else
            this.setState({
              error: { name: "general", text: res.data.error },
              loading: false,
            });
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            error: { name: "general", text: "Server Error Try Again" },
            loading: false,
          });
        });
  };
  render() {
    const { email, password, error, loading } = this.state;
    const mobile = this.props.windowWidth < 1000;

    return (
      <Column>
        <img
          src={Page_Background}
          style={{
            position: "fixed",
            height: "100vh",
            minWidth: "100vw",
            zIndex: -1,
          }}
        />
        <InfoBox
          padding="0"
          margin="10vh auto auto auto"
          borderRadius="20px"
          maxWidth="600px"
          width={mobile ? "75vw" : "45vw"}
        >
          <Column width="100%">
            <Button
              margin=".5%"
              width="5%"
              onClick={() => this.props.history.push("/login")}
            >
              <FontAwesomeIcon
                style={{ margin: "auto 5% auto auto" }}
                icon={faArrowLeft}
              />
              Back
            </Button>
            <Image
              margin="-5% auto auto auto"
              src={Logo}
              height={mobile ? "20vw" : "10vw"}
            />
            <Text size="120%" margin="-5% auto 2% auto">
              Aviary
            </Text>
          </Column>
          <Row>
            <Input
              label="Display Name"
              placeholder="Name of user"
              height="6vh"
              width={"70%"}
              onChange={(v) => this.setState({ name: v })}
            />
          </Row>
          <Input
            label="Email"
            type="email"
            height="6vh"
            width={"70%"}
            onChange={(v) => this.setState({ email: v })}
          />
          <Input
            width="70%"
            height="6vh"
            label="Password"
            type="password"
            onChange={(v) => this.setState({ password: v })}
          />{" "}
          <Input
            width="70%"
            height="6vh"
            label="Confirm Password"
            type="password"
            onChange={(v) => this.setState({ passwordConfirm: v })}
            onKeyUp={(e) => {
              if (e.key === "Enter") this.signup();
            }}
          />
          <Text margin="auto" color="red">
            {error.name == "general" && error.text}
          </Text>
          <Button
            width={"70%"}
            loading={loading}
            margin="3% auto 3% auto"
            onClick={this.signup}
          >
            Signup
          </Button>
        </InfoBox>
      </Column>
    );
  }
}
export default windowSize(Login);
